import { render, staticRenderFns } from "./DocTemplateGenerate.vue?vue&type=template&id=74e516f2&"
import script from "./DocTemplateGenerate.vue?vue&type=script&lang=ts&"
export * from "./DocTemplateGenerate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports